const DESKTOP_SIZE_BREAKPOINT_MIN = 1200;
const TABLET_SIZE_BREAKPOINT_MAX = 1199.99;
const TABLET_SIZE_BREAKPOINT_MIN = 576;
const MOBILE_SIZE_BREAKPOINT_MAX = 575.99;
const SMALL_MOBILE_SIZE_BREAKPOINT_MAX = 350;
const LARGE_MOBILE_SIZE_BREAKPOINT_MAX = 400;

interface IScreenSizes {
  desktop: boolean;
  tablet: boolean;
  mobile: boolean;
}

interface IScreenDimensions {
  desktop: number;
  tablet: number;
  mobile: number;
}

interface IScreenOrientation {
  portrait: boolean;
  landscape: boolean;
}

interface Spacing {
  s_0: number;
  s_1: number;
  s_2: number;
  s_3: number;
  s_4: number;
  s_5: number;
  s_6: number;
  s_7: number;
  s_8: number;
  s_9: number;
  s_10: number;
}

export type { Spacing, IScreenOrientation, IScreenSizes, IScreenDimensions };
export {
  DESKTOP_SIZE_BREAKPOINT_MIN,
  TABLET_SIZE_BREAKPOINT_MIN,
  TABLET_SIZE_BREAKPOINT_MAX,
  MOBILE_SIZE_BREAKPOINT_MAX,
  LARGE_MOBILE_SIZE_BREAKPOINT_MAX,
  SMALL_MOBILE_SIZE_BREAKPOINT_MAX,
};
